/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_vipUserRelationship = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbPcs_vipUserRelationship">;
    readonly " $refType": "PdpRespSimilarItemsLanding_vipUserRelationship";
};
export type PdpRespSimilarItemsLanding_vipUserRelationship$data = PdpRespSimilarItemsLanding_vipUserRelationship;
export type PdpRespSimilarItemsLanding_vipUserRelationship$key = {
    readonly " $data"?: PdpRespSimilarItemsLanding_vipUserRelationship$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsLanding_vipUserRelationship">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsLanding_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_vipUserRelationship",
      "args": null
    }
  ]
};
(node as any).hash = 'cbf915fda449c4e4476b3f405a3650aa';
export default node;
